module.exports = __webpack_public_path__ + "static/img/out1.006c1b34.png";